export enum ELeasePacketUrls {
  LEASE_PACKET = 'lease-packet',
  VERIFY = 'verify',
  CODE = 'code',
}
